import { render } from "./AddAdminUser.vue?vue&type=template&id=26fdad60"
import script from "./AddAdminUser.vue?vue&type=script&lang=js"
export * from "./AddAdminUser.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__